// const logo = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/logo.png';
// const heroImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/heroLarge.png';
// const heroImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/heroSmall.png';
// const heroImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/heroXSmall.png';
// const exploreImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/exploreLarge.png';
// const exploreImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/exploreSmall.png';
// const exploreImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/exploreXSmall.png';
import { themePrimaryColorsBrand } from '../style-constants';

export default {
  extendedTheme: () => ({
    logo: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/logo.png'),
    heroImageLarge: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/heroLarge.png'),
    exploreImageLarge: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/luxury-collection/exploreLarge.png'),
    palette: {
      primary: {
        main: themePrimaryColorsBrand.LC,
      },
      secondary: {
        main: '#565656',
      },
      primaryBtnHover: {
        main: '#5D2F40',
      },
      buttonText: {
        main: '#ffffff',
      },
      interaction: {
        main: '#b43c6a',
      },
      text: {
        primary: '#1c1c1c',
      },
      link: {
        primary: '#1c1c1c',
      },
    },
    typography: {
      useNextVariants: true,
      fontFamily: [
        '"ProximaNova-Regular"',
        '"Roboto"',
        '"Helvetica"',
        '"Arial"',
        'sans-serif',
      ].join(','),
    },
  }),
  typography: (theme, remCalc) => {
    return {
      h1: {
        fontFamily: 'Acta-Medium',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(54),
          lineHeight: 1.11,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(34),
          lineHeight: 1.24,
        },
      },
      h2: {
        fontFamily: 'Acta-Medium',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(40),
          lineHeight: 1.15,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(30),
          lineHeight: 1.2,
        },
      },
    };
  },
  extraTypography: (theme, remCalc) => {
    return {
      hero: {
        fontFamily: 'Acta-Medium',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
      },
      card: {
        fontFamily: 'Acta-Medium',
        fontWeight: 'bold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(38),
          lineHeight: 1.16,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(28),
          lineHeight: 1.21,
        },
      },
    };
  },
};
